var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "plan-preview col",
      class: [
        "radius" + _vm.Global.mockupConfig.radiusRatio,
        _vm.Global.mockupConfig.activeFont,
      ],
    },
    [
      _c("div", { staticClass: "preview col" }, [
        _c("h5", { style: { color: _vm.Global.mockupConfig.colors.icons } }, [
          _vm._v(_vm._s(_vm.plan.name || "Plan name")),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ft-bld txt-ctr" }, [
          _vm._v("All our content, ad-free, offline, and in the background"),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c(
              "span",
              {
                staticClass: "ico",
                style: { background: _vm.Global.mockupConfig.colors.icons },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        y: "10.6067",
                        width: "3",
                        height: "10",
                        transform: "rotate(-45 0 10.6067)",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        width: "3",
                        height: "15",
                        transform:
                          "matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [
              _vm._v("+300 exclusive contents"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "span",
              {
                staticClass: "ico",
                style: { background: _vm.Global.mockupConfig.colors.icons },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        y: "10.6067",
                        width: "3",
                        height: "10",
                        transform: "rotate(-45 0 10.6067)",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        width: "3",
                        height: "15",
                        transform:
                          "matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [
              _vm._v("Ad-free & background play"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "span",
              {
                staticClass: "ico",
                style: { background: _vm.Global.mockupConfig.colors.icons },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        y: "10.6067",
                        width: "3",
                        height: "10",
                        transform: "rotate(-45 0 10.6067)",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        width: "3",
                        height: "15",
                        transform:
                          "matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [
              _vm._v("Downloads for offline viewing"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main n-pre",
            style: { background: _vm.Global.mockupConfig.colors.icons },
          },
          [
            _vm.plan.freeDays !== 0
              ? _c("span", { staticClass: "txt" }, [
                  _vm._v(
                    "Try " +
                      _vm._s(_vm.plan.freeDays) +
                      " day" +
                      _vm._s(_vm.plan.freeDays > 1 ? "s" : "") +
                      " for free"
                  ),
                ])
              : _c("span", { staticClass: "txt" }, [_vm._v("Subscribe")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "price-tag ft-xbld",
            style: { color: _vm.Global.mockupConfig.colors.icons },
          },
          [
            _c("span", { staticClass: "b" }, [
              _vm._v(_vm._s(_vm.displayPrice) + "€"),
            ]),
            _vm._v(
              "\n            / " +
                _vm._s(_vm.displayPriceType == "monthly" ? "month" : "year") +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "trial-cap" }, [
          _vm._v("Billed automatically after trial"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.plan.model == "both",
              expression: "plan.model == 'both'",
            },
          ],
          staticClass: "switcher ft-xbld",
        },
        [
          _c(
            "span",
            {
              class: { active: !_vm.isYearly },
              style: [
                !_vm.isYearly
                  ? { color: _vm.Global.mockupConfig.colors.icons }
                  : "",
              ],
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.changePricing.apply(null, arguments)
                },
              },
            },
            [_vm._v("Monthly")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "switch",
              class: { tgld: _vm.isYearly },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.changePricing.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "48",
                    height: "28",
                    viewBox: "0 0 70 40",
                    fill: "none",
                  },
                },
                [
                  _c("rect", {
                    staticClass: "bk-rect",
                    attrs: {
                      opacity: "0.15",
                      width: "70",
                      height: "40",
                      rx: "20",
                      fill: "white",
                    },
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    staticClass: "dot",
                    attrs: {
                      x: "4",
                      y: "4",
                      width: "32",
                      height: "32",
                      rx: "16",
                      fill: _vm.Global.mockupConfig.colors.icons,
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              class: { active: _vm.isYearly },
              style: [
                _vm.isYearly
                  ? { color: _vm.Global.mockupConfig.colors.icons }
                  : "",
              ],
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.changePricing.apply(null, arguments)
                },
              },
            },
            [
              _vm._v("\n            Yearly "),
              _c("br"),
              _vm._v("(" + _vm._s(_vm.yearlyPercentOff) + "% off)\n        "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }